import Swiper, {Pagination, Navigation, A11y} from "../../../_snowpack/pkg/swiper.js";
const lang = document.documentElement.lang;
const carouselSwiper = new Swiper(".entity-slider--image .swiper-container", {
  modules: [Pagination, Navigation, A11y],
  a11y: lang === "de" ? {
    paginationBulletMessage: "Gehe zu Folie {{index}}",
    firstSlideMessage: "Dies ist die erste Folie",
    prevSlideMessage: "Vorherige Folie",
    lastSlideMessage: "Dies ist die letzte Folie",
    slideLabelMessage: "{{index}} / {{slidesLength}}",
    nextSlideMessage: "Nächste Folie"
  } : {
    paginationBulletMessage: "Go to slide {{index}}",
    firstSlideMessage: "This is the first slide",
    prevSlideMessage: "Previous slide",
    lastSlideMessage: "This is the last slide",
    slideLabelMessage: "{{index}} / {{slidesLength}}",
    nextSlideMessage: "Next slide"
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true
  },
  slidesPerView: 1,
  spaceBetween: 0,
  grabCursor: true,
  centeredSlides: true,
  centerInsufficientSlides: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
for (const tile of document.querySelectorAll(".tile__image-wrapper--with-slider")) {
  tile.addEventListener("click", function(event) {
    tile.classList.add("slider--enabled");
  });
}
